import React from 'react';
export function DeliveryBullets() {
  return null;
}